<template>
  <div class="panel-container">
    <div class="header-container">
      <el-form inline class="header-form" :model="formData">
        <el-form-item :label="$str.getKey('收益管理/电价名称')">
          <el-input :placeholder="$str.getKey('收益管理/请输入电价名称')" v-model="formData.priceName" clearable></el-input>
        </el-form-item>
        <el-form-item :label="$str.getKey('收益管理/日期范围')">
          <el-date-picker type="daterange" :range-separator="$str.getKey('收益管理/至')" v-model="formData.effectiveTimer" :disabled-date="disabledDate">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="需量电价(元/kW)">
          <el-input-number v-model="formData.demandPrice" :min="0" :precision="6" :step="0.1" controls-position="right" />
        </el-form-item>
      </el-form>
    </div>
    <template v-if="!hidePriceTable">
    <!-- 按国网电价+++充放电价一致 -->
    <div v-if="operateType === 'GW_SAME'" class="main-container gw-same-container">
      <div class="table-container">
        <div class="t-header">
          <div class="tr">
            <div class="td">{{ $str.getKey('收益管理/时段名称') }}</div>
            <div class="td">{{ $str.getKey('收益管理/电价（元/kWh）') }}</div>
          </div>
        </div>
        <div class="t-body">
          <div class="tr" v-for="item in formData.tableData.GW_SAME" :key="item" :style="{'--symbol-color': item.color}">
            <div class="td name-cell">
              <div class="symbol-icon"></div>
              <div class="name-text">{{ item.name }}</div>
            </div>
            <div class="td">
              <el-input-number :placeholder="$str.getKey('收益管理/请输入电价')" v-model="item.value" :min="0" :precision="6" :step="0.1" controls-position="right" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 按国网电价+++充放电价不一致 -->
    <div v-if="operateType === 'GW_DIFF'" class="main-container gw-diff-container">
      <!-- 充电 -->
      <div class="table-container charge-table">
        <div class="t-header">
          <div class="tr">
            <div class="td">{{ $str.getKey('收益管理/状态') }}</div>
            <div class="td">{{ $str.getKey('收益管理/时段名称') }}</div>
            <div class="td">{{ $str.getKey('收益管理/电价（元/kWh）') }}</div>
          </div>
        </div>
        <div class="t-body">
          <div class="left-container">
            <img :src="rechargeIcon" class="icon-img" />
            <div class="icon-info">{{ $str.getKey('收益管理/充电') }}</div>
          </div>
          <div class="right-container">
            <div class="tr" v-for="item in formData.tableData.GW_DIFF.in" :key="item" :style="{'--symbol-color': item.color}">
              <div class="td name-cell">
                <div class="symbol-icon"></div>
                <div class="name-text">{{ item.name }}</div>
              </div>
              <div class="td">
                <el-input-number :placeholder="$str.getKey('收益管理/请输入电价')" v-model="item.value" :min="0" :precision="6" :step="0.1" controls-position="right" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 放电 -->
      <div class="table-container discharge-table">
        <div class="t-header">
          <div class="tr">
            <div class="td">{{ $str.getKey('收益管理/状态') }}</div>
            <div class="td">{{ $str.getKey('收益管理/时段名称') }}</div>
            <div class="td">{{ $str.getKey('收益管理/电价（元/kWh）') }}</div>
          </div>
        </div>
        <div class="t-body">
          <div class="left-container">
            <img :src="dischargeIcon" class="icon-img" />
            <div class="icon-info">{{ $str.getKey('收益管理/放电') }}</div>
          </div>
          <div class="right-container">
            <div class="tr" v-for="item in formData.tableData.GW_DIFF.out" :key="item" :style="{'--symbol-color': item.color}">
              <div class="td name-cell">
                <div class="symbol-icon"></div>
                <div class="name-text">{{ item.name }}</div>
              </div>
              <div class="td">
                <el-input-number :placeholder="$str.getKey('收益管理/请输入电价')" v-model="item.value" :min="0" :precision="6" :step="0.1" controls-position="right" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 按电能值估算+++充放时段一致+++充放电价一致 -->
    <div v-if="operateType === 'CUSTOM_SAME'" class="main-container custom-same-container">
      <div class="table-container">
        <div class="t-header">
          <div class="tr">
            <div class="td">{{ $str.getKey('收益管理/开始时间') }}</div>
            <div class="td">{{ $str.getKey('收益管理/结束时间') }}</div>
            <div class="td">{{ $str.getKey('收益管理/时段名称') }}</div>
            <div class="td">{{ $str.getKey('收益管理/电价（元/kWh）') }}</div>
            <div class="td">{{ $str.getKey('收益管理/操作') }}</div>
          </div>
        </div>
        <div class="t-body">
          <div class="tr" v-for="(item, idx) in formData.tableData.CUSTOM_SAME" :key="item" :style="{'--symbol-color': item.color}">
            <div class="td ellipse-input-wrapper">
              <el-time-select v-model="item.startTime" class="custom-ellipse-time-select" :placeholder="$str.getKey('收益管理/开始时间')" format="HH:mm" start="00:00" end="24:00" step="00:15" max-time="23:59"
                style="--el-date-editor-width: auto;" @focus="onTimeFocus($event, item.startTime)">
              </el-time-select>
            </div>
            <div class="td ellipse-input-wrapper">
              <el-time-select v-model="item.endTime" class="custom-ellipse-time-select" :placeholder="$str.getKey('收益管理/结束时间')" format="HH:mm" start="00:00" end="24:00" step="00:15" min-time="00:00"
                style="--el-date-editor-width: auto" @focus="onTimeFocus($event, item.endTime)" @change="onTimeChange($event, item, 'endTime')" @blur="onTimeChange($event, item, 'endTime')">
              </el-time-select>
            </div>
            <div class="td name-cell ellipse-input-wrapper">
              <el-select v-model="item.key" class="custom-ellipse-select" filterable default-first-option :reserve-keyword="false" :placeholder="$str.getKey('收益管理/请选择名称')">
                <el-option v-for="item in origin.sigmentOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </div>
            <div class="td">
              <el-input-number :placeholder="$str.getKey('收益管理/请输入电价')" v-model="item.price" :min="0" :precision="6" :step="0.1" controls-position="right" />
            </div>
            <div class="td operate-cell">
              <el-button class="add-btn" :icon="Plus" link @click="onAddCustomRow(idx, item)"></el-button>
              <el-button class="delete-btn" :icon="Delete" link @click="onDeleteRow(idx, item)" :disabled="formData.tableData.CUSTOM_SAME.length < 2"></el-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 按电能值估算+++充放时段一致+++充放电价不同 -->
    <div v-if="operateType === 'CUSTOM_DIFF'" class="main-container custom-diff-container">
      <div class="table-container">
        <div class="t-header">
          <div class="tr">
            <div class="td">{{ $str.getKey('收益管理/开始时间') }}</div>
            <div class="td">{{ $str.getKey('收益管理/结束时间') }}</div>
            <div class="td">{{ $str.getKey('收益管理/时段名称') }}</div>
            <div class="td">{{ $str.getKey('收益管理/充电电价（元/kWh）') }}</div>
            <div class="td">{{ $str.getKey('收益管理/放电电价（元/kWh）') }}</div>
            <div class="td">{{ $str.getKey('收益管理/操作') }}</div>
          </div>
        </div>
        <div class="t-body">
          <div class="tr" v-for="(item, idx) in formData.tableData.CUSTOM_DIFF" :key="item" :style="{'--symbol-color': item.color}">
            <div class="td ellipse-input-wrapper">
              <el-time-select v-model="item.startTime" class="custom-ellipse-time-select" :placeholder="$str.getKey('收益管理/开始时间')" format="HH:mm" start="00:00" end="24:00" step="00:15" max-time="23:59"
                style="--el-date-editor-width: auto;" @focus="onTimeFocus($event, item.startTime)">
              </el-time-select>
            </div>
            <div class="td ellipse-input-wrapper">
              <el-time-select v-model="item.endTime" class="custom-ellipse-time-select" :placeholder="$str.getKey('收益管理/结束时间')" format="HH:mm" start="00:00" end="24:00" step="00:15" min-time="00:00"
                style="--el-date-editor-width: auto" @focus="onTimeFocus($event, item.endTime)" @change="onTimeChange($event, item, 'endTime')" @blur="onTimeChange($event, item, 'endTime')">
              </el-time-select>
            </div>
            <div class="td name-cell ellipse-input-wrapper">
              <el-select v-model="item.key" class="custom-ellipse-select" filterable default-first-option :reserve-keyword="false" :placeholder="$str.getKey('收益管理/请选择名称')">
                <el-option v-for="item in origin.sigmentOptions" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </div>
            <div class="td">
              <el-input-number :placeholder="$str.getKey('收益管理/请输入电价')" v-model="item.inPrice" :min="0" :precision="6" :step="0.1" controls-position="right" />
            </div>
            <div class="td">
              <el-input-number :placeholder="$str.getKey('收益管理/请输入电价')" v-model="item.outPrice" :min="0" :precision="6" :step="0.1" controls-position="right" />
            </div>
            <div class="td operate-cell">
              <el-button class="add-btn" :icon="Plus" link @click="onAddCustomRow(idx, item)"></el-button>
              <el-button class="delete-btn" :icon="Delete" link @click="onDeleteRow(idx, item)" :disabled="formData.tableData.CUSTOM_DIFF.length < 2"></el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    </template>

  </div>
</template>

<script setup>
import { ref, reactive, defineProps, defineOptions, watch, computed, nextTick, defineEmits } from "vue"
import dayjs from 'dayjs';
import { cloneDeep } from "@/utils/index.js"
import { queryGWElecPrice } from './api/index.js'
import useAppStore from "@/store/modules/app";
import { Helper } from "./index.js";
import rechargeIcon from "@/assets/production/recharge.png";
import dischargeIcon from "@/assets/production/discharge.png";
import { Plus, Delete } from '@element-plus/icons-vue'

const $str = window.$str;

/** 设置组件配置项 */
defineOptions({
  name: "ElectrovalencePanel"
});

/** 接收父组件信息 */
const props = defineProps({
  presetData: {
    type: Object,
    default: {}
  },
});

const emit = defineEmits(['gwInfoUpdate', 'previewChange']);

const stationId = computed(() => {
  return useAppStore().stationId
})

const origin = new Helper();
const baseInfo = reactive({
  isValid: false, // 标记baseInfo数据是否有效
  elecPriceId: '',
  stationId: '',
  priceName: '',
  demandPrice: 0,
  startDate: '',
  endDate: '',
  isUseGwPrice: true,
  isInOutDiff: false,
  priceInfo: null
})





const operateType = computed(() => props.presetData.operateType);
const editType = computed(() => props.presetData.editType); // 'add' 'reCreate' 'edit'
/** 现货模式下仅保留顶部名称与日期，表格由弹窗内现货区域承载 */
const hidePriceTable = computed(() => props.presetData.hidePriceTable === true)
// 用于回显的原始数据
watch(() => props.presetData.originInfo, (nv) => {
  if (nv) {
    baseInfo.elecPriceId = nv.id;
    baseInfo.stationId = nv.stationId;
    baseInfo.priceName = nv.priceName;
    baseInfo.demandPrice = resolveDemandPrice(nv);
    baseInfo.startDate = nv.startDate;
    baseInfo.endDate = nv.endDate;
    baseInfo.isUseGwPrice = nv.type === 1 ? true : false;
    baseInfo.isInOutDiff = nv.chargeType === 2 ? false : true;
    // 要回显的数据：按国网电价+充放一致
    if (baseInfo.isUseGwPrice && !baseInfo.isInOutDiff) {
      baseInfo.priceInfo = {
        sharpPrice: getPriceValue('sharp', nv.priceDetails, 'chargePrice'),
        peakPrice: getPriceValue('peak', nv.priceDetails, 'chargePrice'),
        flatPrice: getPriceValue('flat', nv.priceDetails, 'chargePrice'),
        valleyPrice: getPriceValue('valley', nv.priceDetails, 'chargePrice'),
        deepValleyPrice: getPriceValue('deepValley', nv.priceDetails, 'chargePrice'),
      }
      baseInfo.isValid = true;
    }

    // 要回显的数据：按国网电价+充放不同
    if (baseInfo.isUseGwPrice && baseInfo.isInOutDiff) {
      baseInfo.priceInfo = {
        // 充电
        inSharpPrice: getPriceValue('sharp', nv.priceDetails, 'chargePrice'),
        inPeakPrice: getPriceValue('peak', nv.priceDetails, 'chargePrice'),
        inFlatPrice: getPriceValue('flat', nv.priceDetails, 'chargePrice'),
        inValleyPrice: getPriceValue('valley', nv.priceDetails, 'chargePrice'),
        inDeepValleyPrice: getPriceValue('deepValley', nv.priceDetails, 'chargePrice'),
        // 放电
        outSharpPrice: getPriceValue('sharp', nv.priceDetails, 'dischargePrice'),
        outPeakPrice: getPriceValue('peak', nv.priceDetails, 'dischargePrice'),
        outFlatPrice: getPriceValue('flat', nv.priceDetails, 'dischargePrice'),
        outValleyPrice: getPriceValue('valley', nv.priceDetails, 'dischargePrice'),
        outDeepValleyPrice: getPriceValue('deepValley', nv.priceDetails, 'dischargePrice'),
      }
      baseInfo.isValid = true;
    }

    // 要回显的数据：按电能估算+充放一致
    if (!baseInfo.isUseGwPrice && !baseInfo.isInOutDiff) {
      if (Array.isArray(nv.priceDetails)) {
        baseInfo.priceInfo = nv.priceDetails.map(it => {
          const item = {
            startTime: it.startTime,
            endTime: it.endTime,
            key: it.name, // 和下来选项的value字段保持一致
            price: it.chargePrice,
          }
          return item;
        });
        baseInfo.isValid = true;
      }
    }

    // 要回显的数据：按电能估算+充放不同
    if (!baseInfo.isUseGwPrice && baseInfo.isInOutDiff) {
      if (Array.isArray(nv.priceDetails)) {
        baseInfo.priceInfo = nv.priceDetails.map(it => {
          const item = {
            startTime: it.startTime,
            endTime: it.endTime,
            key: it.name, // 和下来选项的value字段保持一致
            inPrice: it.chargePrice,
            outPrice: it.dischargePrice,
          }
          return item;
        });
        baseInfo.isValid = true;
      }
    }

    refreshBaseDataForPanel(); // 刷新用于回显的基础数据
  }
})

// 根据父组件选择的国网电价的月份，从服务请求该月份的国网电价信息进行参考
watch(() => props.presetData.gwMonth, (nv) => {
  if (nv) {
    // 获取国网电价
    getElecPriceFromGW(nv);
  } else {
    window.dispatchNotify({
      type: 'warning',
      message: $str.getKey('收益管理/请选择查询国网电价的月份')
    })
  }

}, {immediate: true});


const formData = reactive({
  priceName: '',
  demandPrice: 0,
  effectiveTimer: [dayjs().startOf('month'), dayjs().endOf('month')],
  tableData: {
    // 按国网电价-充放电价一致
    GW_SAME: origin.GW_SAME,
    GW_DIFF: origin.GW_DIFF,
    CUSTOM_SAME: origin.CUSTOM_SAME,
    CUSTOM_DIFF: origin.CUSTOM_DIFF,
  },
})


/** ------ 初始化面板 ------ */
initPanel();
defineExpose({ getCommitData, getPreviewData });



/** ====== [业务：功能方法] =================================================================== */
watch(operateType, (nv, ov) => {
  if (nv) {
    formData.tableData[nv] = cloneDeep(origin[nv]);
  }  
  if (ov) {
    formData.tableData[ov] = cloneDeep(origin[ov]);
  }

  emitPreviewChange()
}, {immediate: true})

watch(
  () => formData.tableData[operateType.value],
  () => {
    emitPreviewChange()
  },
  { deep: true }
)





/** 设置禁选日期 */
function disabledDate(date) {
  // 一年之前的日期不能选
  if (date < dayjs().subtract(1, 'year')) {
    return true;
  }
}



/** 添加一行 */
function onAddCustomRow(idx, rowInfo) {
  const type = operateType.value;
  const newItem = origin.createItem(type);
  if (isNaN(idx)) {
    formData.tableData[type].push(newItem);
    // 使用scroll-bar，尾部插入时，自动滚动到最后一行。
  } else {
    formData.tableData[type].splice((idx+1), 0, newItem);
  }
}

/** 删除一行 */
function onDeleteRow(idx, rowInfo) {
  formData.tableData[operateType.value].splice((idx), 1);
}





/** ====== [辅助：功能方法] =================================================================== */
/** 初始化面板 */
async function initPanel() {
  // await getElecPriceFromGW(); // 获取国网电价
}

/** 获取国网电价 */
async function getElecPriceFromGW(month) {
  const params = {
    stationId: stationId.value,
    month: dayjs(month).format('YYYY-MM-DD')
  }

  // 获取国网电价
  return queryGWElecPrice(params).then(res => {
    if (res && typeof(res) === 'object') {
      const priceList = {
        inSharpPrice: res.inSharpPrice ?? 0,
        inPeakPrice: res.inPeakPrice ?? 0,
        inFlatPrice: res.inFlatPrice ?? 0,
        inValleyPrice: res.inValleyPrice ?? 0,
        inDeepValleyPrice: res.inDeepValleyPrice ?? 0,
        
        outSharpPrice: res.outSharpPrice ?? 0,
        outPeakPrice: res.outPeakPrice ?? 0,
        outFlatPrice: res.outFlatPrice ?? 0,
        outValleyPrice: res.outValleyPrice ?? 0,
        outDeepValleyPrice: res.outDeepValleyPrice ?? 0,
      }

      // 基于国网电价-刷新原始数据
      origin.refreshHelperByGwInfo(priceList);

      // 通知父组件：请求的国网电价信息发生变化，更新【国网电价】图片的回显&相关提示信息
      const toParentInfo = {
        imgUrl: res.imgUrl ?? '',
        tipInfo: res.tipInfo ?? ''
      }
      emit('gwInfoUpdate', toParentInfo);
    }
  }).finally(() => {
    // 刷新用于回显的基础数据
    refreshBaseDataForPanel();

    // 用origin中管理的对应状态的数据，更新面板的渲染
    formData.tableData[operateType.value] = origin[operateType.value];

  })
}


/** 返回用户录入的电价信息 */
function getCommitData() {
  // 规整需要提交的数据
  const commitData = {
    priceName: formData.priceName,
    demandPrice: formData.demandPrice,
    dateRange: formData.effectiveTimer,
    operateType: operateType.value,
    tableData: formData.tableData[operateType.value],
  }
  return cloneDeep(commitData);
}

/** 返回预览数据（避免深拷贝，给弹窗右侧图表轻量刷新） */
function getPreviewData() {
  return {
    operateType: operateType.value,
    demandPrice: formData.demandPrice,
    tableData: formData.tableData[operateType.value],
  }
}

function emitPreviewChange() {
  emit('previewChange', getPreviewData())
}



/** 时间选择器定制处理：修改最后一个时间为 23:59 >>> 默认为 00:00 且步进15min时，无法直接设置为 23:59 */
let focusedElement = null
function onTimeFocus(event) {
  focusedElement = event.target;
  nextTick(() => {
    // 查找当前打开的下拉框 将最后一行的日期改为23:59
    const popovers = document.querySelectorAll('.el-popper')
    for (const popoverDom of popovers) {
      const display = getComputedStyle(popoverDom, null).display;
      if (display !== 'none') {
        const last = Array.from(popoverDom.querySelectorAll('.el-select-dropdown__item')).at(-1);
        if (last.innerHTML.includes('00:00')) {
          last.innerHTML = '23:59';
        }
      }
    }
  })
}
function onTimeChange(event, data, key) {
  nextTick(() => {
    if (data[key] === '00:00' || data[key] === '23:59') {
      focusedElement && (focusedElement.value = '23:59');
      data[key] = '23:59';
    }
  })
}



/** 获取电价信息：从给定的数据列表中-基于指定key */
function getPriceValue(searchKey, dataList, valueKey) {
  if (Array.isArray(dataList)) {
    const item = dataList.find(it => it.name === searchKey);
    if (item) {
      return item[valueKey] ?? 0;
    } else {
      return 0;
    }
  }
}

function resolveDemandPrice(data) {
  if (!data || typeof data !== 'object') return 0
  const raw = data.demandPrice
    ?? data.basePrice?.demandPrice
    ?? data.customPrice?.demandPrice
  const val = +raw
  return Number.isFinite(val) && val >= 0 ? val : 0
}

/** 刷新用于回显的基础数据 >>> 编辑状态&&回显数据可用时 */
function refreshBaseDataForPanel() {
  if (editType.value !== 'add' && baseInfo.isValid) {
    // 刷新对应panel的item数据
    if (baseInfo.isUseGwPrice && !baseInfo.isInOutDiff) {
      origin.refresh_GW_SAME(baseInfo.priceInfo);
    }
    if (baseInfo.isUseGwPrice && baseInfo.isInOutDiff) {
      origin.refresh_GW_DIFF(baseInfo.priceInfo);
    }
    if (!baseInfo.isUseGwPrice && !baseInfo.isInOutDiff) {
      origin.refresh_CUSTOM_SAME(baseInfo.priceInfo);
    }
    if (!baseInfo.isUseGwPrice && baseInfo.isInOutDiff) {
      origin.refresh_CUSTOM_DIFF(baseInfo.priceInfo);
    }
    formData.priceName = baseInfo.priceName; // 回显电价名称
    formData.demandPrice = baseInfo.demandPrice;
    formData.effectiveTimer = [baseInfo.startDate, baseInfo.endDate]; 
    formData.tableData[operateType.value] = origin[operateType.value]; // 回显item信息
  }
}

</script>

<style lang="scss" scoped>
.panel-container {
  & {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  .header-container {
    .header-form {
      // 电价名称输入框、日期范围选择器：椭圆形 UI
      :deep(.el-input .el-input__wrapper) {
        border-radius: 999px !important;
      }

      :deep(.el-range-editor.el-input__wrapper) {
        border-radius: 999px !important;
      }
    }
  }

  .main-container {
    // 表格中电价输入框：椭圆形 UI
    :deep(.el-input-number .el-input__wrapper) {
      border-radius: 999px !important;
    }
    
    // 确保数字输入框的按钮不覆盖边框
    :deep(.el-input-number) {
      position: relative !important;
      
      .el-input {
        position: relative !important;
        
          .el-input__wrapper {
          border-radius: 999px !important;
          overflow: visible !important;
          position: relative !important;
          box-sizing: border-box !important;
          padding-right: 36px !important;
        }
      }
      
      // 按钮容器样式，确保在边框内部，不覆盖边框
      .el-input-number__controls {
        position: absolute !important;
        right: 1px !important;
        top: 1px !important;
        bottom: 1px !important;
        width: 32px !important;
        max-width: 32px !important;
        border-radius: 0 999px 999px 0 !important;
        background: transparent !important;
        z-index: 0 !important;
        pointer-events: auto !important;
        margin: 0 !important;
        padding: 0 !important;
        // 调整按钮容器的布局，让圆形按钮居中显示
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        justify-content: center !important;
        gap: 4px !important;
        
        .el-input-number__increase,
        .el-input-number__decrease {
          border: none !important;
          background: transparent !important;
          height: 20px !important;
          width: 20px !important;
          min-width: 20px !important;
          max-width: 20px !important;
          min-height: 20px !important;
          max-height: 20px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          margin: 0 !important;
          padding: 0 !important;
          border-radius: 50% !important;
          flex-shrink: 0 !important;
        }
      }
      
      // 确保输入框内容不被按钮覆盖
      .el-input__inner {
        padding-right: 0 !important;
      }
    }

    &.gw-same-container {
      width: 100%;
      height: 100%;

      .table-container {
        .t-header, .t-body {
          & {
            display: flex;
            flex-direction: column;
            gap: 10px;
          }
          .tr {
            width: 58%;
            height: 36px;
            display: flex;
            justify-content: space-between;
            background: var(--level3-bg-color);
            border-radius: 3px;

            .td {
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
          &.t-header {
            margin-bottom: 10px;
            .tr {
              position: relative;
              &::after {
                content: '';
                position: absolute;
                bottom: -5px;
                left: 50%;
                transform: translateX(-50%);
                background: #EDF2F6;
                width: 100%;
                height: 1px;
              }
            }
          }
          &.t-body {
            .tr:not(:last-child) {
              position: relative;
              &::after {
                content: '';
                position: absolute;
                bottom: -5px;
                left: 50%;
                transform: translateX(-50%);
                background: #EDF2F6;
                width: 100%;
                height: 1px;
              }
            }
            .name-cell {
              gap: 8px;
              .symbol-icon {
                width: 16px;
                height: 16px;
                border: 4px solid var(--symbol-color);
                border-radius: 50%;
              }
              .name-text {
                min-width: 60px;
              }
            }
          }
        }
      }

    }

    &.gw-diff-container {
      & {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: space-between;
        gap: 30px;
      }

      .table-container {
        & {
          height: 100%;
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
        }
        .t-header, .t-body {
          & {
            width: 100%;
          }
          .tr {
            width: 100%;
            height: 36px;
            display: flex;
            justify-content: space-between;
            background: var(--level3-bg-color);
            border-radius: 3px;

            .td {
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
          &.t-header {
            margin-bottom: 10px;
            .tr {
              position: relative;
              &::after {
                content: '';
                position: absolute;
                bottom: -5px;
                left: 50%;
                transform: translateX(-50%);
                background: #EDF2F6;
                width: 100%;
                height: 1px;
              }
            }
          }
          &.t-body {
            width: 100%;
            height: 100%;
            display: flex;
            gap: 10px;
            .right-container {
              .tr:not(:last-child) {
                position: relative;
                &::after {
                  content: '';
                  position: absolute;
                  bottom: -4px;
                  left: 50%;
                  transform: translateX(-50%);
                  background: #EDF2F6;
                  width: 100%;
                  height: 1px;
                }
              }
            }
            .left-container {
              & {
                width: 33.33%;
                height: 100%;
                background: var(--level3-bg-color);
                border-radius: 3px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                gap: 10px;
              }
              .icon-img {
                width: 45%;
              }
              .icon-info {
                color: #98A2BB;
              }
            }

            .right-container {
              width: 66.66%;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              gap: 8px;

              .name-cell {
                gap: 8px;
                .symbol-icon {
                  width: 16px;
                  height: 16px;
                  border: 4px solid var(--symbol-color);
                  border-radius: 50%;
                }
                .name-text {
                  min-width: 60px;
                }
              }
            }



          }
        }
      }
    }

    &.custom-same-container, &.custom-diff-container {
      width: 100%;
      height: 100%;

      .table-container {
        .t-header, .t-body {
          & {
            display: flex;
            flex-direction: column;
            gap: 10px;
          }
          .tr {
            // width: 58%;
            height: 36px;
            display: flex;
            justify-content: space-between;
            background: var(--level3-bg-color);
            border-radius: 3px;
            gap: 8px;

            .td {
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
          &.t-header {
            margin-bottom: 10px;
            .tr {
              position: relative;
              &::after {
                content: '';
                position: absolute;
                bottom: -5px;
                left: 50%;
                transform: translateX(-50%);
                background: #EDF2F6;
                width: 100%;
                height: 1px;
              }
            }
          }
          &.t-body {
            .tr:not(:last-child) {
              position: relative;
              &::after {
                content: '';
                position: absolute;
                bottom: -5px;
                left: 50%;
                transform: translateX(-50%);
                background: #EDF2F6;
                width: 100%;
                height: 1px;
              }
            }
            .name-cell {
              gap: 8px;
              .symbol-icon {
                width: 16px;
                height: 16px;
                border: 4px solid var(--symbol-color);
                border-radius: 50%;
              }
            }
          }
        }
      }
    }

    // CUSTOM_DIFF 和 CUSTOM_SAME 模式下：开始时间、结束时间、时段名称组件为椭圆形 UI
    &.custom-diff-container,
    &.custom-same-container {
      // Element Plus 的 el-select 使用 el-select__wrapper
      ::v-deep .custom-ellipse-time-select,
      ::v-deep .custom-ellipse-select {
        width: 100%;
        
        .el-select__wrapper {
          border-radius: 999px !important;
        }
      }

      // 通过包装器设置样式
      .ellipse-input-wrapper {
        ::v-deep .el-select {
          width: 100%;
          
          .el-select__wrapper {
            border-radius: 999px !important;
          }
        }
      }
    }
  }

}

</style>

<style lang="scss">
// 全局样式：CUSTOM_DIFF 和 CUSTOM_SAME 模式下组件椭圆形 UI（确保优先级）
// Element Plus 的 el-select 使用 el-select__wrapper
.custom-diff-container,
.custom-same-container {
  .custom-ellipse-time-select,
  .custom-ellipse-select {
    .el-select__wrapper {
      border-radius: 999px !important;
    }
  }
  
  // 更通用的选择器
  .el-select {
    .el-select__wrapper {
      border-radius: 999px !important;
    }
  }
}

// 更强制性的全局选择器
.custom-diff-container .custom-ellipse-time-select .el-select__wrapper,
.custom-diff-container .custom-ellipse-select .el-select__wrapper,
.custom-same-container .custom-ellipse-time-select .el-select__wrapper,
.custom-same-container .custom-ellipse-select .el-select__wrapper {
  border-radius: 999px !important;
}
</style>
